<template>
  <NFormItem v-bind="formItemBaseAttrs">
    <BaseDatePicker class="n-datetime-picker" v-bind="componentAttrs" />
  </NFormItem>
</template>

<script setup>
import { useLanguage } from '@/hooks';
import { computed, useAttrs } from 'vue';
import { useFormItemBaseAttrs } from './hooks/useFormItemBaseAttrs';

const attrs = useAttrs();
const { tl } = useLanguage();

const props = defineProps({
  label: String,
  name: [String, Array],
  customLabel: String,
});

const { formItemBaseAttrs, componentBaseAttrs } = useFormItemBaseAttrs(props);

const componentAttrs = computed(() => ({
  ...componentBaseAttrs.value,
  ...attrs,
  showTime: true,
  format: 'YYYY/MM/DD HH:mm:ss',
  valueFormat: 'x',
  inputReadOnly: true,
  placeholder: tl('pleaseSelectTime'),
}));
</script>

<script>
export default {
  name: 'NDatetimePicker',
  inheritAttrs: false,
};
</script>

<style lang="less">
.n-datetime-picker {
  width: 100%;
}
</style>
